<template>
    <div class="tradeOrder">
        <order-list></order-list>
    </div>
</template>

<script>
  import orderList from '@/components/user/details/common/order/orderList'
  export default {
    name: 'index',
    components:{
      orderList,
    },
  };
</script>

<style scoped>

</style>
